// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  text-align: center;
}

.test-detail-subtitle {
  margin: 0 0 0.45rem;
  font-size: 0.8rem;
  color: #6b7280;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-fields {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

@media (max-width: 800px) {
  .test-detail-fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 520px) {
  .test-detail-fields {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-wbm-titration-detail.component.scss"],"names":[],"mappings":"AAAA;EAAuB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAKxF;;AAJA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;EAAwB,kBAAA;AAcnJ;;AAbA;EAAwB,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,gBAAA;EAAkB,kBAAA;EAAoB,yBAAA;EAA2B,sBAAA;AAuBjJ;;AAtBA;EAAsB,aAAA;EAAe,gDAAA;EAAkD,iBAAA;AA4BvF;;AA3BA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,WAAA;AAiC5D;;AAhCA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,WAAA;EAAa,gBAAA;AAuCjE;;AArCA;EACC;IAAsB,gDAAA;EAyCrB;AACF;AAvCA;EACC;IAAsB,0BAAA;EA0CrB;AACF","sourcesContent":[".test-detail-section { border: 1px solid #e3e8ef; border-radius: 4px; padding: 0.65rem; background: #ffffff; }\n.test-detail-title { margin: 0 0 0.55rem; font-size: 0.85rem; font-weight: 700; color: #3f4954; text-transform: uppercase; letter-spacing: 0.02em; text-align: center; }\n.test-detail-subtitle { margin: 0 0 0.45rem; font-size: 0.8rem; color: #6b7280; font-weight: 700; text-align: center; text-transform: uppercase; letter-spacing: 0.02em; }\n.test-detail-fields { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 0.65rem 1rem; }\n.test-detail-field { display: flex; flex-direction: column; gap: 0.3rem; }\n.test-detail-label { margin: 0; font-size: 0.85rem; color: #555; font-weight: 600; }\n\n@media (max-width: 800px) {\n\t.test-detail-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (max-width: 520px) {\n\t.test-detail-fields { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
